import { render, staticRenderFns } from "./RatingPlanShow.vue?vue&type=template&id=6648eba0&"
import script from "./RatingPlanShow.vue?vue&type=script&lang=js&"
export * from "./RatingPlanShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports